import Decimal from 'decimal.js'
import type { TaxTemplate } from 'src/types/quoteTotalsTypes'

Decimal.set({ precision: 50, rounding: Decimal.ROUND_HALF_UP })

export function buildTaxDetailsWithAllocatedBases({
	vatRates,
	overallTotal,
	subTotal,
	totalDiscount,
	getTotalAmountForRate,
}: {
	vatRates: number[]
	overallTotal: number
	subTotal: number
	totalDiscount: number
	getTotalAmountForRate: (taxRate: number) => number
}) {
	if (!overallTotal) {
		return {
			taxArray: vatRates.map((taxRate) => ({
				taxRate,
				taxPercentage: taxRate * 100,
				taxAmount: 0,
				taxableAmount: 0,
			})),
			totalTaxAmount: 0,
		}
	}

	const overallTotalDecimal = new Decimal(overallTotal)
	const subTotalDecimal = new Decimal(subTotal || 0)
	const totalDiscountDecimal = new Decimal(totalDiscount || 0)
	const taxArray: TaxTemplate[] = []
	let previousTaxableAmount = new Decimal(0)
	let totalTaxAmount = new Decimal(0)

	for (let i = 0; i < vatRates.length; i++) {
		const taxRate = vatRates[i]
		const taxPercentage = taxRate * 100
		const totalAmountDecimal = new Decimal(
			getTotalAmountForRate(taxRate) || 0
		)
		const taxableAmountDecimal =
			i === vatRates.length - 1
				? subTotalDecimal.minus(previousTaxableAmount)
				: totalAmountDecimal.minus(
						totalDiscountDecimal
							.times(totalAmountDecimal)
							.dividedBy(overallTotalDecimal)
					)
		const taxableAmount = parseFloat(taxableAmountDecimal.toFixed(2))
		const taxAmount = parseFloat(
			new Decimal(taxableAmount).times(taxRate).toFixed(2)
		)

		previousTaxableAmount = previousTaxableAmount.plus(taxableAmount)
		totalTaxAmount = totalTaxAmount.plus(taxAmount)
		taxArray.push({
			taxRate,
			taxPercentage,
			taxAmount,
			taxableAmount,
		})
	}

	return {
		taxArray,
		totalTaxAmount: parseFloat(totalTaxAmount.toFixed(2)),
	}
}
